import { render, staticRenderFns } from "./zijia.vue?vue&type=template&id=28cc2f4a"
import script from "./zijia.vue?vue&type=script&lang=js"
export * from "./zijia.vue?vue&type=script&lang=js"
import style0 from "./zijia.vue?vue&type=style&index=0&id=28cc2f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports